export default "__VITE_ASSET__Ca_QyuGF__"